export function openWithPost(url, values) {
  const newWindow = window.open('', '_blank');
  if (!newWindow) return false;
  let html = '';
  html += `<html><head></head><body><form id='formid' method='post' action='${url}'>`;
  Object.keys(values).forEach((key) => {
    html += `<input type='hidden' name='${key}' value='${values[key]}'/>`;
  });
  html += '</form><script type="text/javascript">document.getElementById("formid").submit()</script></body></html>';
  newWindow.document.write(html);
  return newWindow;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}
